import { Inject, forwardRef, Injectable, EventEmitter } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { PathNode, Task, UserTask } from '@mprep/shared/data/models'

@Injectable()
export class PathNodeCalculationServiceMock {

  constructor(
  ) { }

  /**
   * @return Observable containing the percent completed for the given pathNode
   */
  public pathNodeCompletion(pathNode: PathNode): Observable<number> {
    return Observable.of(42)
  }

  public onPathNodeCompletionCalculation(pathNode: PathNode): Observable<number> {
    return Observable.of(42)
  }

  /**
   * @return Observable/EventEmitter that contains the percent completed whenever a user task changes
   */
  public onPathNodeCompletionChange(pathNode: PathNode): EventEmitter<number> {
    return new EventEmitter<number>()
  }

  private notifyTaskListeners(userTask: UserTask) {
  }

  private calculatePercentComplete(tasks: Task[], userTasks: UserTask[]): number {
    return 23
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/path-node-calculation.service.mock.ts